import styled from 'styled-components'

export const Wrapper = styled.div`
  width: 100%;
  min-height: 100%;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
`

export const Content = styled.main`
  margin: 0;
  width: 100%;
  display: flex;
  flex-grow: 1;
  align-items: stretch;
  justify-content: center;
  flex-wrap: wrap;

  // overriding general styling of paragraphs for cart page only
  p {
    font-family: ${({ theme }) => theme.fontFamilies.roboto};
  }
`
